import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { QuestionExpectedAnswerType } from '@app/shared/common/enums';
import { AnswerContentHRScoreItems, AnswerContentHRScoreResponse } from '@app/vinter/models/answer-content-form-item';
import { AnswerContentHRScoreService } from '@app/vinter/services/answer-content-hr-score.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-simple-vinter-change-vinter-score',
  templateUrl: './simple-vinter-change-vinter-score.component.html',
  styleUrls: ['./simple-vinter-change-vinter-score.component.scss']
})
export class SimpleVinterChangeVinterScoreSidebarComponent implements OnInit{

  @Input() scoreChangeSidebarVisible: boolean = false;
  @Input() changeScoreSidebarVisible: boolean = false;
  @Input() questionScoreDecPart: number;
  @Input() questionScoreIntPart: number;
  @Output() changeScoreSidebarVisibleChange = new EventEmitter<boolean>();
  @Input() scoreChange!: number; 
  @Output() scoreChangeChange = new EventEmitter<number>();
  @Input() isScoreChanged: boolean = false;
  @Output() isScoreChangedChange = new EventEmitter<boolean>();
  @Output() sidebarClosed = new EventEmitter<void>();
  @Output() questionDetail = new EventEmitter<void>();
  @Input() vinterScore: number = 0;
  @Input() key: any;
  @Input() isMultipleChoiceQuestion: boolean;
  @Input() answerContentID: string;
  @Input() applicantID: string;
  @Output() scoreChanged = new EventEmitter<number>();

  hrScoreDetails:  AnswerContentHRScoreResponse[];
  QuestionExpectedAnswerType = QuestionExpectedAnswerType;
  choices : any [];
  value: number;
  firstAIScore: number;
  content: string = ""
  isEditorHidden: boolean = true;
  initialValue: number;
  isCommentAdded: boolean
  lastChangedScore: number;
  fullValue: number;
  valueToAdded: number;
  fractionValue: number = 0;
  difference: number = 0;
  sortAscending: boolean = true;
  isDataChanged: boolean = false;
  private scoreSubject = new BehaviorSubject<number>(this.vinterScore);
  score$ = this.scoreSubject.asObservable();

  formats=[
    'bold',
    'italic',
    'underline',
    'list',
  ];
  text: string = '<div>Hello World!</div><div>PrimeNG <b>Editor</b> Rocks</div><div><br></div>';

  colorRanges = [
    { min: 90, max: 100, color: '#16ba13' },
    { min: 80, max: 90, color: '#01ce2d' },
    { min: 70, max: 80, color: '#6fe819' },
    { min: 60, max: 70, color: '#afe705' },
    { min: 50, max: 60, color: '#d7ee06' },
    { min: 40, max: 50, color: '#fbdf0b' },
    { min: 30, max: 40, color: '#fdba04' },
    { min: 10, max: 30, color: '#ff8307' },
    { min: 0, max: 10, color: '#F91E00' }
  ];

  constructor(
    private answerContentHRScoreService : AnswerContentHRScoreService,
    private cdr: ChangeDetectorRef
  ){

  }

  ngOnInit() {
    this.getChangedScoreData(this.answerContentID, this.applicantID);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getChangedScoreData(this.answerContentID, this.applicantID);
  }
  
  sortByCreatedAt() {
    this.hrScoreDetails.sort((a, b) => {
      const dateA = new Date(a.createdAt).getTime();
      const dateB = new Date(b.createdAt).getTime();
      return this.sortAscending ? dateA - dateB : dateB - dateA;
    });
    this.sortAscending = !this.sortAscending;
  }

  onSliderChange(event: any): void {
    const newValue = event.value;
    const originalScore = this.vinterScore; 
    this.difference = newValue - originalScore;
  
    this.isDataChanged = this.lastChangedScore !== newValue;
    this.updateSliderStyles();
  }
  
getSliderColor(value: number): string {
  const range = this.colorRanges.find(r => value >= r.min && value <= r.max);
  return range ? range.color : '#ECECEC';
}

private updateSliderStyles(): void {
  const sliderElement: HTMLElement | null = document.querySelector('.custom-slider .p-slider-range');
  if (sliderElement) {
      const color = this.getSliderColor(this.value);
      sliderElement.style.backgroundColor = color;
  }
}
showEditor(){
  this.isEditorHidden = false;
}

saveButton(){
  if(this.isDataChanged){
    const postData: AnswerContentHRScoreItems = {
      scoreChange: this.difference,
      hrComment: this.cleanHtmlTags(this.content),
      answerContentID: this.answerContentID,
      applicantID: this.applicantID,
    };

    this.answerContentHRScoreService.setAsnwerContentHRScoreChange(postData).subscribe(() => {
      const filter = { answerContentID: this.answerContentID, applicantID: this.applicantID };
      this.getChangedScoreData(this.answerContentID, this.applicantID);
      this.isScoreChanged = true;
      this.scoreChanged.emit(this.value);
    });
  }
}

checkEditorContent(): void {
  const cleanContent = this.cleanHtmlTags(this.content);
  this.isCommentAdded = !!cleanContent && cleanContent.trim().length > 0 && this.content != null;
  this.isDataChanged = this.isCommentAdded;
}

cleanHtmlTags(input: string): string {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return (doc.body.textContent ?? false) && doc.body.textContent != 'undefined' ? doc.body.textContent : '';
}

calculateValue(scoreChange: number): number {
  return Math.min(100, Math.max(0, this.vinterScore + scoreChange));
}

getChangedScoreData(answerContentID, applicantID){
  const filter = { answerContentID, applicantID };
  this.answerContentHRScoreService.getChangedScoreData(filter).subscribe((response: AnswerContentHRScoreResponse[]) => {
    this.hrScoreDetails = response;
    if (this.hrScoreDetails?.length > 0) {
      const scoreChange = this.hrScoreDetails[0].scoreChange;
      const updatedScore = Math.min(100, Math.max(0, this.vinterScore + scoreChange));

      this.value = updatedScore;
      this.lastChangedScore = updatedScore;
      this.scoreSubject.next(updatedScore);
    }
    this.cdr.detectChanges();
  });
}
}
